<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-4">
          <div slot="header">
            <h4 class="card-title pl-1 f-20-mobile">Atualizar Produtos por Planilha</h4>
          </div>
          <div class="col-md-6 mb-3">
            <label>Empresa originária dos dados (Buscar por idi ou CNPJ)</label>
              <input type="text" v-model="pesquisa_original" v-debounce:250ms="pesquisaInstalacaoOriginal" class="form-control">
              <div class="mt-2 bold">
                 <div>Idi: {{ empresa_original.idi }}</div>
                 <div>CNPJ: {{ empresa_original.cnpj }}</div>
                 <div>Apelido: {{ empresa_original.apelido }}</div>
                 <div>R. Social: {{ empresa_original.razao_social }}</div>
              </div>
          </div>
          <div class="col-md-6 mb-3 pl-0">
          <input ref="inputFile" :disabled="!empresa_original || !empresa_original.idi" type="file" @change="processFile($event)" class="form-control">
          </div>
          <div class="pt-3 pb-1 d-inline">
            <button :disabled="!empresa_original || !empresa_original.idi" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="baixarProdutos">Exportar Produtos</button>

            <download-csv
              :data="json_data"
              name="Produtos.csv"
              ref="generator"
              encoding="utf-8"
              delimiter=";"
              style="display: none;"
            >
            </download-csv>
          </div>
          <div class="pt-3 pb-1 d-inline ml-4">
            <button :disabled="error || !planilha || !pesquisa_original || !(empresa_original && empresa_original.idi)" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary" @click="subirPlanilha">Atualizar produtos</button>
          </div>

          <div v-if="csvDecodificado">{{ csvDecodificado.length - 1 }} produto(s) selecionado(s)</div>
          <div v-if="error" style="color: red; font-weight: bold;">Arquivo inválido, verifique-o e tente novamente</div>
          <div v-for="err of err_data">{{ err }} </div>

          <div class="changelog mt-4" v-if="!error && csvDecodificado">
            <table class="table table-bordered">
              <thead>
                <th v-for="header of csvDecodificado[0]">{{ header }}</th>
              </thead>
              <tbody>
                <template v-for="(row, index) of csvDecodificado">
                  <tr v-if="index !== 0">
                    <template v-for="line of row">
                      <td :class="line.status" :title="line.oldValue">{{ line.newValue }}</td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import {
  Card,
} from 'src/components'
import moment from 'moment'
import "vue-select/dist/vue-select.css";
import loadApp from '@/services/InstalacaoService.js'
import AuthService from '@/services/AuthService.js'
import ProdutoService from '@/services/ProdutoService.js'
import ProdutoCategoriaService from '@/services/ProdutoCategoriaService.js'

export default {
    components: {
      Card,
      moment,
    },
    data() {
      return {
        planilha:null,
        csvDecodificado: 0,
        success:false,
        fail:false,
        idi:null,
        mensagem_erro:null,
        pesquisa_original:"",
        empresa_original:{
          idi: ''
        },
        empresa: '',
        json_data: [],
        error: false,
        err_data: []
      }
    },
    methods:{
      processFile(event) {
        var reader = new FileReader();
        reader.onload = (e)=>{
          this.planilha = e.target.result

          this.validateCSV(this.planilha)
        }
        
        reader.readAsText(event.target.files[0])
      },
      async validateCSV(planilha) {   
        this.error = false;     
        let csv = this.planilha.split(/\r?\n|\r|\n/g)

        for(let row of csv) {
          if(row.split(';').length != 21 && row.split(';').length != 22 && row.length != 0) {
            this.err_data.push(row)
            this.error = true
            this.csvDecodificado = null;
            break;
          }
        }

        let produtos = await this.baixarProdutos(false)

        if(!this.error) {
          this.error = false;
          let csvDecoded = this.planilha.split(/\r?\n|\r|\n/g)
          let data = []

          let i = 0;
          
          for(let row of csvDecoded) {
            let rowSplitada = row.split(';')
            
            if(i > 0) {
              let produtoEncontrado = produtos.find(el => el.Id == rowSplitada[0])

              if(produtoEncontrado) {
                let index = 0; 

                for(const [key, value] of Object.entries(produtoEncontrado)) {
                  if(rowSplitada[index] == value || (rowSplitada[index] == '' && value == null)) {
                    rowSplitada[index] = {
                      oldValue: value,
                      newValue: rowSplitada[index],
                      status: 'unchanged'
                    }
                  } else {
                    rowSplitada[index] = {
                      oldValue: value,
                      newValue: rowSplitada[index],
                      status: 'changed'
                    }
                  }

                  index++;
                }
              } else {
                let novo = false; 

                if(rowSplitada[0] == '' || rowSplitada[0] == null) {
                  novo = true
                }

                for(let index = 0; index < rowSplitada.length; index++) {
                  rowSplitada[index] = {
                    oldValue: '',
                    newValue: rowSplitada[index],
                    status: novo ? 'ignored' : 'error'
                  }
                }
              }


            }
            data.push(rowSplitada)
           
            i++;
          }

          this.csvDecodificado = data
        }

        this.$forceUpdate()
      },
      async baixarProdutos(exportCsv = true) {
        let token = await AuthService.selectIdiApp({ idi: this.pesquisa_original }).then(async res => {
          return res.data.token
        })

        let categorias = await ProdutoCategoriaService.load(undefined, token).then(res => {
          return res.data
        })

        let response = await ProdutoService.loadRaw(`?query=` + "&todos_produtos=true&lote=false&excel=true", token)
        let dados = []
        let total = 0;
        for(let item of response.data.data.data) {
          const filtered_categorias = categorias.filter((categoria) => {
            return categoria.codigo == item.categoria_id
          })

          let nome_categoria = ''
          if(filtered_categorias.length){
            nome_categoria = filtered_categorias[0].nome
          }

          let tmp = {
            "Id": item.codigo,
            "Código": item.referencia ? item.referencia.trim() : '',
            "Nome": item.descricao ? item.descricao.trim() : '',
            "Categoria": nome_categoria ? nome_categoria.trim() : '',
            "Valor de Venda": this.$filters.currencyBrl(item.valor_venda),
            "Tipo": item.complemento ? "Complemento" : "",
          };

          tmp["NCM"] =  item.ncm_sh
          tmp["CFOP"] = item.cfop
          tmp["CST"] = item.cst
          tmp["CEST"] = item.cest
          tmp["Código de Benefício Fiscal"] = item.c_benef
          tmp["Código da Nota"] = item.referencia_nota_emissao
          tmp["PIS"] = item.pis_cst
          tmp["COFINS"] = item.cofins_cst
          tmp["Valor de Custo"] = item.valor_custo
          tmp["Codigo Da Natureza"] = item.tipo_sped
          tmp["ICMS"] = item.p_icms
          tmp["Redução de ICMS "] = item.p_red_bc
          tmp["Aliquota PIS"] = item.pis_aliq
          tmp["Aliquota COFINS"] = item.cofins_aliq
          tmp["Codigo de Barra"] = item.eans && item.eans.length > 0 ? item.eans[0].ean : ''

          dados.push(tmp)
        }

        if(exportCsv) {
          this.json_data = dados

          setTimeout(() => {
            this.$refs.generator.generate();
          }, 300)
        } else {
          return dados
        }
      },
      subirPlanilha(){
        let params = {
          "idi": this.empresa_original.idi,
          "file": this.planilha
        }

        if(this.error) {
          return
        }

        axios.post(process.env.VUE_APP_API_MOBILE_URL+'instalacoes/updatecsv', params,{
            "Content-Type": "multipart/form-data"
          }).then(res => {
            this.$swal({
              title:"Sucesso!",
              icon:"success",
              text:"Produtos atualizados com sucesso!"
            })

            this.validateCSV(this.planilhas)
        }).catch(err=>{
          this.$swal({
            title:"Erro",
            icon:"warning",
            text: err.response.data ? err.response.data.message : 'Erro interno!'
          })
        });
      },
      pesquisaInstalacaoOriginal(){
        this.clear()
        loadApp.loadApp(this.pesquisa_original).then(res => {
          this.empresa_original = res.data[0]
          if(!this.empresa_original){
            this.empresa_original = {idi:null,cnpj:"Nenhuma Empresa Encontrada",nome_fantasia:"Nenhuma Empresa Encontrada"}
          }
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
        })
      },
      clear() {
        this.error = false;
        this.err_data = []
        this.json_data = [];
        this.planilha = null
        this.csvDecodificado = null
        this.$refs.inputFile.value = null;
        this.$forceUpdate()
      }
    }
}
</script>

<style>
  .flex-center-div {
    display: flex;
    align-items: center;
  }

  .changed {
    background-color: #2ecc71;
  }

  .error {
    background-color: red;
    color: white;
  }

  .ignored {
    background-color: #bbb;
  }
</style>
